import { useState, useEffect, useContext  } from 'react';
import { useNavigate } from 'react-router-dom';

import {SettingsContext} from '../components/userSettingsContext';
import {CcLoader, TabSelector} from '../commonComponents/generalComponents';
import {CcCheckbox, FileSelector, InputText, LionListbox, LionCombo} from  '../commonComponents/inputFields'

import { Alert, AlertTitle, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
     Popover, IconButton, Tooltip} from '@mui/material';
import axios from 'axios';
import { Icon as Iconify } from '@iconify/react';
import {InfoToolTip, LionLoaderGradient} from "../commonComponents/generalComponents";
import { lionIcons } from '../components/helpersIcons';
import { ccColorDarkTeal, ccColorSecondaryPink, ccColorSecondaryPurple } from '../components/helpersStyles';
import PageAdminColors from './PageAdminColors';
import PageAdminFonts from './PageAdminFonts'
import PageAdminArtFonts from './PageAdminArtFont';
import PageAdminQuickBlocks from './PageAdminQuickBlocks';
import { CcActionButton, CcActionButtonOutlined, CcCreateNewButton, CcTitle } from '../commonComponents/styledTexts';
import { getErrorListFromYupError, getErrorMessage, getErrorMessageForArray, weatherCollectionValidationSchema } from '../components/helperErrors'

const TimerSettings = (props) => {
    const {settings, setSettings} = useContext(SettingsContext);
    const navigate = useNavigate();
    const [timeZones, setTimeZones] = useState(undefined);

    const [showLoader, setShowLoader] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);


    useEffect(() => {
        getTimezones()
      }, [])
    const getTimezones = async () => {
    try {  
        const url = `${process.env.REACT_APP_LION_API_URL}/Settings/timezones`;
        const response = await axios.get(url);
        const data = response.data;

        const result = data.map(d => {return {id: d.zoneId, name: d.zoneName}});
        setTimeZones(result);

    } catch (error) {
        //console.log(error);
    }
    }
    
      

    const handleSettingChange = (settingName, settingValue) => {
        const newTimerSettings = {...settings.accountSettings.timers, [settingName]: settingValue}
        const newAccountSettings = {...settings.accountSettings, timers: newTimerSettings}
        const newSettings = {...settings, accountSettings: newAccountSettings}
        setSettings(newSettings)
    }
    const handleUpdateSettings = async() => {
        setShowLoader(true)
        try {
          const url = `${process.env.REACT_APP_LION_API_URL}/User/UpdateAccountSettings`;
  
  
          const response = await axios.post(url, settings.accountSettings);
          if (response.data === true) {
            setShowSuccess(true)
          }
          else {
              setShowError(true)
          }

        } catch (error) {
          setShowError(true)
        }
        finally {
          setShowLoader(false);

        }
    }
    const handleGoToHome = () => {
        //navigate("/")
        setShowLoader(false)
        setShowSuccess(false)
        setShowError(false)
    }

    return <div>
        {!showLoader && !showSuccess && !showError && <div className='flex flex-col gap-4'>
            <div className='text-ccColorDarkTeal text-lg font-semibold'>Personalised timers</div>
            <div className='text-ccColorDarkTeal'>Select the correct format for the date/time merge for personalised countdown timers from the list below:</div>
            <div>
                <label htmlFor="snippetHref" className="block text-sm font-medium leading-6 text-gray-900">
                    Merged date format
                </label>
                <div className="">
                <input
                    type="text"
                    name="inputDateFormat"
                    id="timersInputDateFormat"
                    value={settings.accountSettings ? settings.accountSettings.timers.inputDateFormat : ''}
                    onChange={(e) => handleSettingChange('inputDateFormat', e.target.value)}
                    className="block w-56 rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
                </div>
            </div>
            <div>
                <label htmlFor="snippetDescription" className="block text-sm font-medium leading-6 text-gray-900">
                    Default Time zone
                </label>
                <div>
                    <LionCombo items={timeZones}
                    onChange={(item) => handleSettingChange('timeZone', item.id)}
                    selectedItemId={settings.accountSettings ? settings.accountSettings.timers.timeZone : undefined}
                    zIndex={100}
                    />
                </div>
            </div>
            <div className='flex flex-row-reverse'>
                <button type="button" onClick={handleUpdateSettings} className="text-white bg-ccColorDarkTeal hover:bg-ccColorTeal  font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">Update</button>
            </div>
        </div>
        }

        {showLoader && <div className=" container max-w-sm mx-auto flex flex-row justify-center mb-8">
                <LionLoaderGradient /> 
            </div>
        }
        {showSuccess && <div className=" container max-w-md mx-auto flex flex-col justify-center mb-8">
                            <Alert severity="success">
                            <AlertTitle>Success</AlertTitle>
                            <div className='flex flex-col gap-2'>
                                <div>Settings have been updated</div>
                            </div>
                            </Alert>                      
                        </div>
        }
        {showError && <div className=" container max-w-md mx-auto flex flex-col justify-center mb-8">
                            <Alert severity="error">
                            <AlertTitle>Error</AlertTitle>
                            There was an error updating the settings. Please try again later
                            </Alert>                      
                        </div>
        }
        {(showSuccess || showError) && <div className='flex flex-row-reverse'>
                            <button type="button" class="text-white bg-ccColorDarkTeal hover:bg-ccColorTeal font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                                onClick={handleGoToHome}
                            >Done</button>
                            </div>
        }

    </div>
}

const MergeSettings = (props) => {
    const {settings, setSettings} = useContext(SettingsContext);
    const navigate = useNavigate();

    const [showLoader, setShowLoader] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);    
      

    const handleSettingChange = (settingName, settingValue) => {
        const newMergeSettings = {...settings.accountSettings.mergeCodes, [settingName]: settingValue}
        const newAccountSettings = {...settings.accountSettings, mergeCodes: newMergeSettings}
        const newSettings = {...settings, accountSettings: newAccountSettings}
        setSettings(newSettings)
    }
    const handleUserDefinedMergeChange = (changeKeyOrValue, settingName, settingValue) => {
        const newUserDefinedMergeSettings = [...settings.accountSettings.mergeCodes.userDefined]
        const matchIndex = newUserDefinedMergeSettings.findIndex(s => s.key === settingName);
        if (changeKeyOrValue === 'value')
            newUserDefinedMergeSettings[matchIndex].value = settingValue;
        else
            newUserDefinedMergeSettings[matchIndex].key = settingValue;
            

        const newMergeSettings = {...settings.accountSettings.mergeCodes, userDefined: newUserDefinedMergeSettings}
        const newAccountSettings = {...settings.accountSettings, mergeCodes: newMergeSettings}
        const newSettings = {...settings, accountSettings: newAccountSettings}
        setSettings(newSettings)
    }
    const handleDeleteDefinedMerge = (settingName) => {
        const newUserDefinedMergeSettings = [...settings.accountSettings.mergeCodes.userDefined]
        const matchIndex = newUserDefinedMergeSettings.findIndex(s => s.key === settingName);
        newUserDefinedMergeSettings.splice(matchIndex, 1)

        const newMergeSettings = {...settings.accountSettings.mergeCodes, userDefined: newUserDefinedMergeSettings}
        const newAccountSettings = {...settings.accountSettings, mergeCodes: newMergeSettings}
        const newSettings = {...settings, accountSettings: newAccountSettings}
        setSettings(newSettings)

    }
    const handleAddDefinedMerge = () => {
        const newUserDefinedMergeSettings = [...settings.accountSettings.mergeCodes.userDefined, {key: "", value: ""}]

        const newMergeSettings = {...settings.accountSettings.mergeCodes, userDefined: newUserDefinedMergeSettings}
        const newAccountSettings = {...settings.accountSettings, mergeCodes: newMergeSettings}
        const newSettings = {...settings, accountSettings: newAccountSettings}
        setSettings(newSettings)

    }

    const handleUpdateSettings = async() => {
        setShowLoader(true)
        try {
          const url = `${process.env.REACT_APP_LION_API_URL}/User/UpdateAccountSettings`;
  
  
          const response = await axios.post(url, settings.accountSettings);
          if (response.data === true) {
            setShowSuccess(true)
          }
          else {
              setShowError(true)
          }

        } catch (error) {
          setShowError(true)
        }
        finally {
          setShowLoader(false);

        }
    }
    const handleGoToHome = () => {
        //navigate("/")
        setShowLoader(false)
        setShowSuccess(false)
        setShowError(false)
    }

    return <div>
        <div className='mb-2 text-ccColorDarkTeal'>Add the merge codes from your ESP here and we’ll automatically add them to Elements to save you time.</div>
        {!showLoader && !showSuccess && !showError && <div className='flex flex-col gap-4'>
            <div className='flex flex-row gap-24'>
                  <div>
                    <div className='flex flex-row gap-x-2 items-center'>
                        <label htmlFor="snippetHref" className="block text-sm font-medium leading-6 text-gray-900">
                            Firstname
                        </label>
                        <InfoToolTip 
                            placement='right'
                            headLine='Firstname'
                            message='Insert the merge code for the first name from your ESP, the same code you’d use to personalise a greeting like "Hi Firstname." It might look something like %%firstname%% or *|FNAME|*.'
                        />
                    </div>
                    <div className="">
                    <input
                        type="text"
                        name="mergeFirstname"
                        id="mergeFirstname"
                        value={settings.accountSettings ? settings.accountSettings.mergeCodes.firstname : ''}
                        onChange={(e) => handleSettingChange('firstname', e.target.value)}
                        className="block w-56 rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                    </div>
                </div>

                <div>
                    <div className='flex flex-row gap-x-2 items-center'>
                        <label htmlFor="snippetHref" className="block text-sm font-medium leading-6 text-gray-900">
                            User Id
                        </label>
                        <InfoToolTip 
                            placement='right'
                            headLine='User Id'
                            message="Insert the merge code for the unique user identifier from your ESP."
                        />
                    </div>
                    <div className="">
                    <input
                        type="text"
                        name="mergeUserId"
                        id="mergeUserId"
                        value={settings.accountSettings ? settings.accountSettings.mergeCodes.userId : ''}
                        onChange={(e) => handleSettingChange('userId', e.target.value)}
                        className="block w-56 rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                    </div>
                </div>

            </div>

            <div className='flex flex-row gap-24'>
                 <div>
                 <div className='flex flex-row gap-x-2 items-center'>
                     <label htmlFor="snippetHref" className="block text-sm font-medium leading-6 text-gray-900">
                        Mailing Id
                    </label>
                    <InfoToolTip 
                        placement='right'
                        headLine='Mailing Id'
                        message="Insert your ESP’s merge code for mailing id from your ESP."
                    />
                </div>
                    <div className="">
                    <input
                        type="text"
                        name="mergeMailingId"
                        id="mergeMailingId"
                        value={settings.accountSettings ? settings.accountSettings.mergeCodes.mailingId : ''}
                        onChange={(e) => handleSettingChange('mailingId', e.target.value)}
                        className="block w-56 rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                    </div>
                </div>

                <div>
                    <div className='flex flex-row gap-x-2 items-center'>
                        <label htmlFor="snippetHref" className="block text-sm font-medium leading-6 text-gray-900">
                            Date of Birth
                        </label>
                        <InfoToolTip 
                            placement='right'
                            headLine='Date of Birth'
                            message="Add this merge code if you’re wanting to send content based around a subscriber’s birthday. This should be a date format merge code."
                        />
                    </div>
                    <div className="">
                    <input
                        type="text"
                        name="mergeDob"
                        id="mergeDob"
                        value={settings.accountSettings ? settings.accountSettings.mergeCodes.dob : ''}
                        onChange={(e) => handleSettingChange('dob', e.target.value)}
                        className="block w-56 rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                    </div>
                </div>

            </div>


            <div className='flex flex-row gap-24'>
               <div>
                   <div className='flex flex-row gap-x-2 items-center'>
                    <label htmlFor="snippetHref" className="block text-sm font-medium leading-6 text-gray-900">
                            Language
                        </label>
                        <InfoToolTip 
                            placement='right'
                            headLine='Language'
                            message="Add the merge code here that determines a subscriber’s preferred language."
                        />
                    </div>
                    <div className="">
                    <input
                        type="text"
                        name="mergeLanguage"
                        id="mergeLanguage"
                        value={settings.accountSettings ? settings.accountSettings.mergeCodes.language : ''}
                        onChange={(e) => handleSettingChange('language', e.target.value)}
                        className="block w-56 rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                    </div>
                </div>            
              <div>
                <div className='flex flex-row gap-x-2 items-center'>
                    <label htmlFor="snippetHref" className="block text-sm font-medium leading-6 text-gray-900">
                        Timer Personalized Date
                    </label>
                        <InfoToolTip 
                            placement='right'
                            headLine='Timer Personalized Date'
                            message="This merge code should be in a date format and could be for a specific event, for example the date/time that the subscriber signed up."
                        />
                    </div>
                    <div className="">
                    <input
                        type="text"
                        name="mergeTimerDate"
                        id="mergeTimerDate"
                        value={settings.accountSettings ? settings.accountSettings.mergeCodes.timerCustomDate : ''}
                        onChange={(e) => handleSettingChange('timerCustomDate', e.target.value)}
                        className="block w-56 rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                    </div>
                </div>
            </div>

            <div className='flex flex-row gap-24'>
               <div>
                   <div className='flex flex-row gap-x-2 items-center'>
                    <label htmlFor="snippetHref" className="block text-sm font-medium leading-6 text-gray-900">
                            City
                        </label>
                        <InfoToolTip 
                            placement='right'
                            headLine='City name'
                            message="Add the merge code here that determines a subscriber’s preferred language."
                        />
                    </div>
                    <div className="">
                    <input
                        type="text"
                        name="mergeCity"
                        id="mergeCity"
                        value={settings.accountSettings ? settings.accountSettings.mergeCodes.city : ''}
                        onChange={(e) => handleSettingChange('city', e.target.value)}
                        className="block w-56 rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                    </div>
                </div>            
              <div>
                <div className='flex flex-row gap-x-2 items-center'>
                    <label htmlFor="snippetHref" className="block text-sm font-medium leading-6 text-gray-900">
                        Country code
                    </label>
                        <InfoToolTip 
                            placement='right'
                            headLine='Country code'
                            message="This merge code should be in a date format and could be for a specific event, for example the date/time that the subscriber signed up."
                        />
                    </div>
                    <div className="">
                    <input
                        type="text"
                        name="mergeCountryCode"
                        id="mergeCountryCode"
                        value={settings.accountSettings ? settings.accountSettings.mergeCodes.countryCode : ''}
                        onChange={(e) => handleSettingChange('countryCode', e.target.value)}
                        className="block w-56 rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                    </div>
                </div>
            </div>


            <div className='flex flex-row gap-24'>
               <div>
                   <div className='flex flex-row gap-x-2 items-center'>
                    <label htmlFor="snippetHref" className="block text-sm font-medium leading-6 text-gray-900">
                            State
                        </label>
                        <InfoToolTip 
                            placement='right'
                            headLine='State'
                            message="Add the merge code here that determines a subscriber’s preferred language."
                        />
                    </div>
                    <div className="">
                    <input
                        type="text"
                        name="mergeState"
                        id="mergeState"
                        value={settings.accountSettings ? settings.accountSettings.mergeCodes.state : ''}
                        onChange={(e) => handleSettingChange('state', e.target.value)}
                        className="block w-56 rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                    </div>
                </div>
            </div>



            <div className='w-[544px] border border-gray-300 rounded-md p-1'>
                <div className='text-ccColorDarkTeal text-lg font-semibold'> Add your own merge codes</div>
                <div className='text-ccColorDarkTeal text-sm mb-2'>In this section you can add your own custom merge codes from your ESP. This means you will be able to add blocks already connected to the data points in the design lab to streamline design and element creation. Please ensure you test these are correct before any live sends.</div>
                <CcCreateNewButton onClick={handleAddDefinedMerge}>Add your own merge code</CcCreateNewButton>

                <div className='flex flex-col gap-6'>
                {settings.accountSettings && settings.accountSettings.mergeCodes.userDefined.map((userSetting, index) => <div className='flex flex-row gap-12'>
                                            <div>
                                                <label htmlFor="snippetHref" className="block text-sm font-medium leading-6 text-gray-900">
                                                Name
                                                </label>
                                                <div className="">
                                                <input
                                                    type="text"
                                                    name="merge"
                                                    id={`${userSetting.key}${index}`}
                                                    value={userSetting.key}
                                                    onChange={(e) => handleUserDefinedMergeChange('key', userSetting.key, e.target.value)}
                                                    className="block w-56 rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                />
                                                </div>
                                            </div>
                                            <div>
                                                <label htmlFor="snippetHref" className="block text-sm font-medium leading-6 text-gray-900">
                                                Merge Code
                                                </label>
                                                <div className="flex flex-row gap-1">
                                                <input
                                                    type="text"
                                                    name="merge"
                                                    id={`${userSetting.value}${index}`}
                                                    value={userSetting.value}
                                                    onChange={(e) => handleUserDefinedMergeChange('value', userSetting.key, e.target.value)}
                                                    className="block w-56 rounded-md border-0 px-1.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                />
                                                <IconButton onClick={() => handleDeleteDefinedMerge(userSetting.key)}><Iconify icon={lionIcons.Icon_Actions_Delete} /></IconButton>
                                                </div>
                                            </div>
                                        </div>
                            )
                }
                </div>
            </div>

            <div className='flex flex-row-reverse'>
                <button type="button" onClick={handleUpdateSettings} className="text-white bg-ccColorDarkTeal hover:bg-gradient-to-br hover:bg-ccColorTeal font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">Update</button>
            </div>
        </div>
        }

        {showLoader && <div className=" container max-w-sm mx-auto flex flex-row justify-center mb-8">
                <LionLoaderGradient /> 
            </div>
        }
        {showSuccess && <div className=" container max-w-md mx-auto flex flex-col justify-center mb-8">
                            <Alert severity="success">
                            <AlertTitle>Success</AlertTitle>
                            <div className='flex flex-col gap-2'>
                                <div>Settings have been updated</div>
                            </div>
                            </Alert>                      
                        </div>
        }
        {showError && <div className=" container max-w-md mx-auto flex flex-col justify-center mb-8">
                            <Alert severity="error">
                            <AlertTitle>Error</AlertTitle>
                            There was an error updating the settings. Please try again later
                            </Alert>                      
                        </div>
        }
        {(showSuccess || showError) && <div className='flex flex-row-reverse'>
                            <button type="button" class="text-white bg-ccColorDarkTeal hover:bg-ccColorTeal font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                                onClick={handleGoToHome}
                            >Done</button>
                            </div>
        }

    </div>
}

const GeneralSettings = (props) => {
    const {settings, setSettings} = useContext(SettingsContext);
    const navigate = useNavigate();
    const [languages, setLanguages] = useState([]);

    const [showLoader, setShowLoader] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);    
      
    useEffect(() => {
        getLanguages()
      }, [])
    const getLanguages = async () => {
    try {  
        const url = `${process.env.REACT_APP_LION_API_URL}/Settings/languages`;
        const response = await axios.get(url);
        const data = response.data;

        setLanguages(data);

    } catch (error) {
        //console.log(error);
    }
    }
    
      
    const handleMappingChange = (lCode, lDisplayName) => {
        let newMappings = [...settings.accountSettings.general.languageMappings]
        const indexMatch = newMappings.findIndex(lm => lm.languageCode === lCode)

        if (indexMatch === -1) {
            newMappings.push({languageCode: lCode, displayName: lDisplayName})
        }
        else newMappings[indexMatch].displayName = lDisplayName;

        const newGeneralSettings = {...settings.accountSettings.general, languageMappings: newMappings}
        const newAccountSettings = {...settings.accountSettings, general: newGeneralSettings}
        const newSettings = {...settings, accountSettings: newAccountSettings}
        setSettings(newSettings)
    }
    const handleDefaultLanguageChange = (lang) => {
        
        const newGeneralSettings = {...settings.accountSettings.general, defaultLanguage: lang.id}
        const newAccountSettings = {...settings.accountSettings, general: newGeneralSettings}
        const newSettings = {...settings, accountSettings: newAccountSettings}
        setSettings(newSettings)

    }

    const handleUpdateSettings = async() => {
        setShowLoader(true)
        try {
          const url = `${process.env.REACT_APP_LION_API_URL}/User/UpdateAccountSettings`;
  
  
          const response = await axios.post(url, settings.accountSettings);
          if (response.data === true) {
            setShowSuccess(true)
          }
          else {
              setShowError(true)
          }

        } catch (error) {
          setShowError(true)
        }
        finally {
          setShowLoader(false);

        }
    }
    const handleGoToHome = () => {
        //navigate("/")
        setShowLoader(false)
        setShowSuccess(false)
        setShowError(false)
    }

    return <div>
        {!showLoader && !showSuccess && !showError && <div className='flex flex-col gap-4'>
            <div className='text-ccColorDarkTeal text-lg font-semibold'>Language Mappings</div>
            <div className='text-ccColorDarkTeal'>Automatically translate timer labels into your recipient's preferred language. When setting up a timer, you can choose the multi-language option. The timer will then include a language parameter that maps to these settings, ensuring the time labels are displayed in the correct language.</div>
            <div>
                <div className="text-sm font-medium leading-6 text-gray-900">
                Default language</div>
                <LionListbox items={languages.map(l => {return {id: l.languageCode, name: l.displayName}})}
                    selectedItemId={settings.accountSettings.general.defaultLanguage}
                    onChange={handleDefaultLanguageChange}
                />
            </div>  
            <div className='flex flex-row'>
                <div className='grid grid-cols-2 gap-y-2 gap-x-8'>
                {
                languages.map(l => {
                let currentMatch = undefined;
                if (settings.accountSettings.general.languageMappings) currentMatch = settings.accountSettings.general.languageMappings.find(lm => lm.languageCode === l.languageCode);
                const currentMapping = currentMatch === undefined ? '' : currentMatch.displayName;
                return <div key={l.languageCode} className='flex flex-row items-center gap-2'>
                <div className='w-40 text-ccColorDarkTeal font-semibold flex justify-end'>{l.displayName}</div>
                <Iconify icon="fluent:arrow-fit-16-regular" width={26} color={ccColorSecondaryPurple} />
                <input
                            type="text"
                            value={currentMapping}
                            onChange={(e) => handleMappingChange(l.languageCode, e.target.value)}
                            className=" block rounded-md border-0 py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
            </div>

            })

            }

                </div>
                <div className=' ml-2 flex grow'></div>
            </div>

            <div className='flex flex-row-reverse'>
                <button type="button" onClick={handleUpdateSettings} className="text-white bg-ccColorDarkTeal hover:bg-gradient-to-br hover:bg-ccColorTeal font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">Update</button>
            </div>
        </div>
        }

        {showLoader && <div className=" container max-w-sm mx-auto flex flex-row justify-center mb-8">
                <LionLoaderGradient /> 
            </div>
        }
        {showSuccess && <div className=" container max-w-md mx-auto flex flex-col justify-center mb-8">
                            <Alert severity="success">
                            <AlertTitle>Success</AlertTitle>
                            <div className='flex flex-col gap-2'>
                                <div>Settings have been updated</div>
                            </div>
                            </Alert>                      
                        </div>
        }
        {showError && <div className=" container max-w-md mx-auto flex flex-col justify-center mb-8">
                            <Alert severity="error">
                            <AlertTitle>Error</AlertTitle>
                            There was an error updating the settings. Please try again later
                            </Alert>                      
                        </div>
        }
        {(showSuccess || showError) && <div className='flex flex-row-reverse'>
                            <button type="button" class="text-white bg-ccColorDarkTeal hover:bg-ccColorTeal font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                                onClick={handleGoToHome}
                            >Done</button>
                            </div>
        }

    </div>
}

const WeatherIconCollectionEditor = (props) => {
    //allows to create and edit a weather collections
    //props:
    //collection: undefined to create new, otherwise it's an edit
    //allWeatherConditions: [{conditionName: xxx, groupName: yyy}]

    //onCancel: users closed this window without saving any change
    //onClose: users closed this window after saving any change

    const [groupNames, setGroupNames] = useState([]) //contains the default groups. Main object to loop for
    const [collection, setCollection] = useState([])
    const [collectionName, setCollectionName] = useState('')
    const [savingCollection, setSavingCollection] = useState(false)
    const [collectionId, setCollectionId] = useState(undefined) // it has a value only when in edit
    const [activeErrorList, setActiveErrorList] = useState([])

    const emptyGroup = {groupName: 'Custom group', iconDayDataURL: '', iconNightDataURL: '', isDefault: false, weatherConditionIds: '[]'}
    const [newGroup, setNewGroup] = useState(emptyGroup)
    const [newGroupErrMsg, setNewGroupErrMsg] = useState('')

    const [anchorEl, setAnchorEl] = useState(null);
    const openDialog = Boolean(anchorEl);
    const handleOpenCustomMappings = (event) => {
        setAnchorEl(event.currentTarget);
        setNewGroup(emptyGroup)
        validateNewGroupName(emptyGroup.groupName)
    };
    
    const handleCloseCustomMappings = (eventOrCmd) => {
    if (eventOrCmd === 'create') {
        const newCollection = [...collection]
        newCollection.push(newGroup)
        //console.log(newCollection)
        setCollection(newCollection)
        runValidation({collectionName: collectionName, collection: newCollection})
    }
    setAnchorEl(null);
    };
      
    const [dialogDeleteGroupOpen, setDialogDeleteGroupOpen] = useState(false);
    const [groupNameToDelete, setGroupNameToDelete] = useState(''); //used in the dialogDeleteGroupOpen. 

    useEffect(() => {
        const uniqueNames = [...new Set(props.allWeatherConditions.map(elem => elem.groupName))];
        setGroupNames(uniqueNames)
        if (props.collection) {
            setCollectionName(props.collection.collectionName)
            setCollection(props.collection.collection)
            setCollectionId(props.collection.weatherCollectionId)
            runValidation({collectionName: props.collection.collectionName, collection: props.collection.collection})
        }
        else {
            setCollection(generateEmptyCollection(uniqueNames))
            setCollectionId(undefined)
        }
    }, [props.allWeatherConditions, props.collection])

    const generateEmptyCollection = (names) => {
        const result = []
        for (const name of names) {
            result.push({groupName: name, iconDayDataURL: '', iconNightDataURL: '', isDefault: false, weatherConditionIds: '[]'})
        }
        return result;
    }
    

    const handleCancel = () => {
        props.onCancel()
    }
    const handleImageChange = (dataURL, isDayVersion, index) => {
        let collectionElem;
        if (isDayVersion) {
            collectionElem = {...collection[index], iconDayDataURL: dataURL }
        }
        else {
            collectionElem = {...collection[index], iconNightDataURL: dataURL }
        }
        const newCollection = [...collection]
        newCollection.splice(index, 1, collectionElem)
        setCollection(newCollection)
    }
    const handleDeleteImage = (isDayVersion, index) => {
        let collectionElem;
        if (isDayVersion) {
            collectionElem = {...collection[index], iconDayDataURL: '' }
        }
        else {
            collectionElem = {...collection[index], iconNightDataURL: '' }
        }
        const newCollection = [...collection]
        newCollection.splice(index, 1, collectionElem)
        setCollection(newCollection)
    }
    const handleCollectionDefaultChange = (isDefault, index) => {

        const newCollection = [...collection]
        for (let i=0; i<collection.length; i+=1) {
            newCollection[i].isDefault = false
            if (i === index) newCollection[i].isDefault = isDefault
        }

        setCollection(newCollection)
    }
    const saveCollection = async () => {
        setSavingCollection(true)
        const valid = runValidation();

        try {  
            const url = `${process.env.REACT_APP_LION_API_URL}/Weather/weatherCollections/save`;
            const dataToPost = {collectionName: collectionName, isValidated: valid,
                                weatherCollectionId: collectionId, collection: collection}
            const response = await axios.post(url, dataToPost);
            const data = response.data;
    
            //console.log(data);
    
        } catch (error) {
            //console.log(error);
        }
        finally {setSavingCollection(false); props.onClose()}
    }
    const runValidation = (objToValidate) => {
        try {
            //console.log(snippetData)
            if (objToValidate) weatherCollectionValidationSchema.validateSync(objToValidate, {abortEarly: false});
            else weatherCollectionValidationSchema.validateSync({collectionName: collectionName, collection: collection}, {abortEarly: false});
            setActiveErrorList([])
            return true;
          }
          catch (e) {
            // IF VALIDATION IS NO PASSED WE RETURN AND DO NOTHING ELSE
    
            //console.log(JSON.parse(JSON.stringify(e)))
            const errorList = getErrorListFromYupError(e)
            //console.log(errorList)
            setActiveErrorList(errorList)
            return false;
          }
    
    }
    const handleChangeNewGroup = (propName, propValue) => {
        const newNewGroup = {...newGroup, [propName]: propValue}

        if (propName === 'groupName') {
            //we want to validate the groupName
            validateNewGroupName(propValue)
        }

        //console.log(newNewGroup)
        setNewGroup(newNewGroup)
    }
    const validateNewGroupName = (groupName) => {
        const allNames = [...new Set(collection.map(c => c.groupName))];
        allNames.includes(groupName) ? setNewGroupErrMsg('Name already used') : setNewGroupErrMsg('')
    }
    const handleCustomMappingChange = (conditionId) => {
        const oldValues = JSON.parse(newGroup.weatherConditionIds)
        const matchIndex = oldValues.findIndex(v => v === conditionId)
        let newValues = [...oldValues]
        if (matchIndex === -1) newValues.push(conditionId)
        else newValues.splice(matchIndex, 1)

        handleChangeNewGroup('weatherConditionIds', JSON.stringify(newValues))
    }

    const renderCustomConditionsMappings = () => {
        let result = []
        //get all already used conditionIds
        let usedIds = []
        for (const c of collection) {
            const ids = JSON.parse(c.weatherConditionIds)

            if (ids.length > 0) usedIds.push(...ids)
        }
        //for the used conditioIds we want o disable the checkboxes below

        for (const currentGroupName of groupNames) {
            const allConditions = props.allWeatherConditions.filter(c => c.groupName === currentGroupName)
            result.push(<div className="text-ccColorDarkTeal font-poppins text-sm grid my-2 p-1 grid-cols-3" >
                    <div className="col-span-3 text-base font-semibold">{currentGroupName}</div>
                    {allConditions.map(c => <div className='-my-1' onClick={() => handleCustomMappingChange(c.weatherConditionId)}>
                        {usedIds.includes(c.weatherConditionId) ?
                            <div className='flex flex-row text-gray-300 items-center gap-x-1 ml-[10px] mt-2'>
                                <Iconify icon="fe:disabled" width={24} />
                                <div>{c.conditionName}</div>
                            </div>
                            :
                            <CcCheckbox displayName={c.conditionName}
                            checked={JSON.parse(newGroup.weatherConditionIds).findIndex(wci => wci === c.weatherConditionId) !== -1}
                        />
                        }
                    </div>)

                    }
            </div>
            )
        }

        return <>{result}</>
    }
    const handleDeleteGroup = (groupName) => {
        setGroupNameToDelete(groupName)
        setDialogDeleteGroupOpen(true)
    }
    const handleDialogDeleteGroupClose = async(action) => {
        if (action === 'delete') {
            const newCollection = [...collection]

            const matchIndex = newCollection.findIndex(c => c.groupName === groupNameToDelete)
            if (matchIndex !== -1) {
                newCollection.splice(matchIndex, 1)
                setCollection(newCollection)
                runValidation({collectionName: collectionName, collection: newCollection})
            }
        }
        setDialogDeleteGroupOpen(false)
    }
    

    return <div className='border rounded flex flex-col gap-y-2 p-1'>
    {!savingCollection && <>
        <div className='flex justify-end w-full text-ccColorDarkTeal p-1 rounded'>
            <div className='hover:bg-slate-100 rounded-full hover:cursor-pointer p-1'
                onClick={handleCancel}>
                <Iconify icon={lionIcons.Icon_Actions_Cancel} width={32} />
            </div>     
        </div>
        {activeErrorList.length > 0 && <div className='w-[540px] font-poppins bg-orange-200 text-orange-800 rounded p-2'>
            <div className='font-semibold'>Your collection is not ready to be used yet</div>
            <div className='text-sm'>To be able to use this collection in your templates, please make sure to </div>

            <ul class="list-disc ml-4">
                    {activeErrorList.map(err => <li>
                    {err.message}
                </li>)}
            </ul>
        </div>
        }
        <div className='w-60 ml-1'>
            <InputText displayName="Collection name" value={collectionName}
                    onChange={setCollectionName} />
        </div>
        {collection.map((c, index) => <div className='mx-1'>
            <div className='border h-[140px] p-2 flex flex-row gap-x-4 rounded font-poppins text-ccColorDarkTeal'>
                <div className='flex flex-row gap-x-1 w-[180px]'>
                    <div className='font-semibold '>{c.groupName}</div>
                    <CoveredConditionsToolTip
                    groupName={c.groupName}
                     allWeatherConditions={props.allWeatherConditions}
                     customConditions={c.weatherConditionIds}
                      />
                </div>
                {c.iconDayDataURL.length === 0 && <div className='flex flex-col items-center justify-end'>
                                            <FileSelector noDeleteButton
                                            text="Upload"
                                            onChange={(val) => handleImageChange(val, true, index)}
                                            />
                                    
                                    <div className='text-sm font-semibold'>Day version</div>
                                </div>
                }
                {c.iconDayDataURL.length > 0 && <div className='relative flex flex-col items-center'>
                                    <img className='w-[100px] h-[100px]' src={c.iconDayDataURL} />
                                    <div className='text-sm font-semibold'>Day version</div>
                                    <div className=' absolute top-0 -right-4 hover:bg-slate-100 rounded-full hover:cursor-pointer p-1'
                                        onClick={() => handleDeleteImage(true, index)}>
                                        <Iconify icon={lionIcons.Icon_Actions_Cancel} width={32} />
                                    </div>     
                                </div>
                }
                <div className='w-6'></div>
                {c.iconNightDataURL.length === 0 && <div className='flex flex-col items-center justify-end'>
                                            <FileSelector noDeleteButton
                                            text="Upload"
                                            onChange={(val) => handleImageChange(val, false, index)}
                                            />
                                    
                                    <div className='text-sm font-semibold'>Night version</div>
                                </div>
                }
                {c.iconNightDataURL.length > 0 && <div className='relative flex flex-col items-center'>
                                    <img className='w-[100px] h-[100px]' src={c.iconNightDataURL} />
                                    <div className='text-sm font-semibold'>Night version</div>
                                    <div className=' absolute top-0 -right-4 hover:bg-slate-100 rounded-full hover:cursor-pointer p-1'
                                        onClick={() => handleDeleteImage(false, index)}>
                                        <Iconify icon={lionIcons.Icon_Actions_Cancel} width={32} />
                                    </div>     
                                </div>
                }
                <div className='flex grow'></div>
                {c.weatherConditionIds !== '[]' && <div className='mt-2 mr-8 flex flex-row items-center h-fit'>
                        <div className='bg-ccColorYellow text-ccColorDarkTeal font-semibold rounded px-1'>Custom</div>
                        <div className='hover:bg-slate-100 rounded-full hover:cursor-pointer p-1'
                            onClick={() => handleDeleteGroup(c.groupName)}>
                            <Iconify icon={lionIcons.Icon_Actions_Delete} width={24} />
                        </div>     
                    </div>
                }
                <div className='mt-1'>
                    <CcCheckbox displayName="Default"
                    checked={c.isDefault}
                    onChange={(e) => {handleCollectionDefaultChange(e.target.checked, index);}}
                    />
                </div>
        
                
            </div>
        </div>)
        }

        <div className='w-fit'>
            <CcActionButtonOutlined onClick={handleOpenCustomMappings}>Add custom group</CcActionButtonOutlined>
        </div>
        <div className='flex justify-end mr-1 mb-1'>
            <CcActionButton onClick={saveCollection}>Save</CcActionButton>
        </div>
    </>   
    }
    {savingCollection && <div className='flex flex-col items-center mt-4 gap-y-2'>
        <CcLoader size={96} />
        <div>Saving...</div>
    </div>

    }

    <Popover    open={openDialog}
                        anchorEl={anchorEl}
                        onClose={handleCloseCustomMappings}
                        anchorOrigin={{
                          vertical: 'top',
                        }}
              >
            <div className='w-[800px] max-h-[620px] px-2'>
            <div className='flex justify-end w-full text-ccColorDarkTeal rounded'>
                <div className='hover:bg-slate-100 rounded-full hover:cursor-pointer p-1'
                    onClick={handleCloseCustomMappings}>
                    <Iconify icon={lionIcons.Icon_Actions_Cancel} width={32} />
                </div>     
            </div>

                <div className='w-60 ml-1'>
                    <InputText displayName="Group name" value={newGroup.groupName}
                        onChange={(val) => handleChangeNewGroup('groupName', val)} 
                        error={newGroupErrMsg}
                        />
                </div>
                <div className='text-ccColorDarkTeal font-poppins mt-2'>
                    Select which weather conditions this group will cover. <span className='font-semibold'>The condition mapped here will have precedence over the standard groups' conditions</span>
                </div>
                <div className='h-[400px] overflow-y-auto'>
                    {renderCustomConditionsMappings()}
                </div>
                <div className='flex justify-end mb-1'>
                    <CcActionButton
                        disabled={newGroupErrMsg.length > 0}
                     onClick={() => handleCloseCustomMappings('create')}>Create</CcActionButton>
                </div>
    
            </div>
        </Popover>
    
    <Dialog onClose={() => handleDialogDeleteGroupClose('abort')} open={dialogDeleteGroupOpen}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description">
        <DialogTitle id="dialog-title"><span className='text-ccColorDarkTeal font-poppins'>Are you sure you want to delete this group?</span></DialogTitle>
        <DialogContent>
            <DialogContentText id="dialog-description">
              
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <CcActionButton onClick={() => handleDialogDeleteGroupClose('abort')}>No</CcActionButton>
            <CcActionButton onClick={() => handleDialogDeleteGroupClose('delete')} autoFocus>
              Yes
            </CcActionButton>
          </DialogActions>    
    </Dialog>
    
</div>
}

const WeatherIconSettings = (props) => {
    const [defaultCollection, setDefaultCollection] = useState([])
    const [defaultCollectionExpanded, setDefaultCollectionExpanded] = useState(false)
    const [allWeatherConditions, setAllWeatherConditions] = useState([])
    const [editMode, setEditMode] = useState(false)
    const [editCollection, setEditCollection] = useState(undefined)
    const [userCollections, setUserCollections] = useState([])

    useEffect(() => {
        getDefaultCollection()
        getAllWeatherConditions()
        getUserCollections()
      }, [])

    const getDefaultCollection = async () => {
    try {  
        const url = `${process.env.REACT_APP_LION_API_URL}/Weather/weatherCollections/default`;
        const response = await axios.get(url);
        const data = response.data;

        setDefaultCollection(data)
        //console.log(data);

    } catch (error) {
        //console.log(error);
    }
    }
    const getAllWeatherConditions = async () => {
        try {  
            const url = `${process.env.REACT_APP_LION_API_URL}/Weather/weatherConditions`;
            const response = await axios.get(url);
            const data = response.data;
    
            setAllWeatherConditions(data)
            //console.log(data);
    
        } catch (error) {
            //console.log(error);
        }
    }
    const getUserCollections = async () => {
        try {  
            const url = `${process.env.REACT_APP_LION_API_URL}/Weather/weatherCollections/mine`;
            const response = await axios.get(url);
            const data = response.data;
    
            setUserCollections(data)
            //console.log(data);
    
        } catch (error) {
            //console.log(error);
        }
    }
        
    const handleToggleDefault = () => {
        setDefaultCollectionExpanded(!defaultCollectionExpanded)
    }
    const handleDuplicateCollection = async (id) => {
        try {  
            const url = `${process.env.REACT_APP_LION_API_URL}/Weather/weatherCollections/duplicate/${id}`;
            const response = await axios.get(url);
            const data = response.data;
    
            getUserCollections()
            setEditCollection(data)
            setEditMode(true)
            //console.log(data);
    
        } catch (error) {
            //console.log(error);
        }

    }

    if (editMode) return <WeatherIconCollectionEditor
                            onCancel={() => setEditMode(false)}
                            onClose={() => {setEditMode(false); getUserCollections()}}
                            allWeatherConditions={allWeatherConditions}
                            collection={editCollection}
                            />
    else return <div>
            <div className='border rounded p-2'>
                <div className='text-ccColorDarkTeal text-lg font-semibold'>Code Chemistry default collection</div>
                {!defaultCollectionExpanded && <div>
                            <div className='flex flex-row gap-x-4'>
                                {defaultCollection.map(elem => <div>
                                    <img src={elem.iconDayDataURL} />
                                </div>)

                                }
                            </div>
                            <div className='text-ccColorDarkTeal flex items-center justify-center rounded-full w-[32px] h-[32px] hover:bg-slate-100 hover:cursor-pointer'
                                onClick={handleToggleDefault}>
                                <Iconify icon="material-symbols:expand-circle-up-outline-rounded" width={24} rotate={90} />
                            </div>
                </div>
                }
                {defaultCollectionExpanded && <div className='mt-2 max-h-[400px] overflow-y-auto'>
                            <div className='flex flex-col text-ccColorDarkTeal font-poppins gap-y-2'>
                                {defaultCollection.map(elem => <div className='border p-2 flex flex-row gap-x-4 rounded'>
                                    <div className='font-semibold w-32'>{elem.groupName}</div>
                                    <div className='flex flex-col items-center'>
                                        <img src={elem.iconDayDataURL} />
                                        <div className='text-sm font-semibold'>Day version</div>
                                    </div>
                                    <div className='flex flex-col items-center ml-8'>
                                        <img src={elem.iconNightDataURL} />
                                        <div className='text-sm font-semibold'>Night version</div>
                                    </div>
                                    {elem.isDefault && <>
                                        <div className='flex grow'></div>
                                         <div className='mr-2'>
                                            <div className='flex flex-row items-center gap-x-2 p-1 rounded bg-ccColorTeal text-white'>
                                                <Iconify icon="mdi:tick-circle-outline" />
                                                <div className='font-semibold text-sm mr-1'>Default</div>
                                            </div>
                                        </div>
                                        </>
                                    }
                                </div>)

                                }
                            </div>
                            <div className='text-ccColorDarkTeal flex items-center justify-center rounded-full w-[32px] h-[32px] hover:bg-slate-100 hover:cursor-pointer'
                                onClick={handleToggleDefault}>
                                <Iconify icon="material-symbols:expand-circle-up-outline-rounded" width={24} />
                            </div>
                </div>
                }
            </div>
            <CcActionButton className="mt-2 mb-2" onClick={() => setEditMode(true)}>Add a weather icon collection</CcActionButton>

            {userCollections.map(uc => <div className='border rounded p-2 mt-4'>
                <div className='flex flex-row'>
                    <div className='text-ccColorDarkTeal text-lg font-semibold'>{uc.collectionName}</div>
                    <div className='flex grow'></div>
                    <div className='flex flex-row gap-x-4 items-center'>
                        {uc.isValidated ? <div className='bg-green-400 rounded text-white px-2 flex flex-row items-center gap-x-2'><Iconify icon={lionIcons.Icon_Alert_Ok} /><div>validated</div></div>
                        :
                        <div className='bg-orange-400 rounded text-white px-2 flex flex-row items-center gap-x-2'><Iconify icon={lionIcons.Icon_Alert_Warning} /><div>not validated</div></div>}
                        <div className="mt-2 mb-2 text-ccColorDarkTeal hover:cursor-pointer hover:bg-slate-100 rounded-full p-1" onClick={() => {setEditCollection(uc); setEditMode(true)}}>
                            <Iconify icon={lionIcons.Icon_Actions_Edit} width={24} />
                        </div>
                        <div className="mt-2 mb-2 text-ccColorDarkTeal hover:cursor-pointer hover:bg-slate-100 rounded-full p-1" onClick={() => {handleDuplicateCollection(uc.weatherCollectionId);}}>
                            <Iconify icon={lionIcons.Icon_Actions_Duplicate} width={24} />
                        </div>
                    </div>
                </div>
                <div className='flex flex-row gap-x-4'>
                    {uc.collection.filter(c => c.iconDayDataURL !== null && c.iconDayDataURL.length > 0).map(elem => <div>
                        <img src={elem.iconDayDataURL} />
                    </div>)
                    }
                </div>

            </div>)}

    </div>
}

const CoveredConditionsToolTip = (props) => {
/*
    props:
    allWeatherConditions: contains all the mappings between a group name and all the covered weather condition ids
    customConditions: if this group has a custom mapping, this is an array of weather condition ids
    groupName:
*/


    const renderConditions = () => {
        let result = []
        const uniqueNames = [...new Set(props.allWeatherConditions.map(elem => elem.groupName))];
        for (const currentGroupName of uniqueNames) {
            const allConditions = props.allWeatherConditions.filter(c => c.groupName === currentGroupName)
            result.push(<div className={`grid my-2 p-1 grid-cols-4 ${currentGroupName === props.groupName ? 'text-ccColorDarkTeal rounded bg-blue-100' : 'text-slate-400'}`}>
                    <div className="col-span-4 text-base font-semibold">{currentGroupName}</div>
                    {allConditions.map(c => <div>
                        {c.conditionName}
                    </div>)

                    }
            </div>
            )
        }

        return <>{result}</>
    }

    const renderCustomConditions = () => {
        const conditions = JSON.parse(props.customConditions)
        //console.log(props.allWeatherConditions)

        const result = []
        for (const condId of conditions) {
            const condInfo = props.allWeatherConditions.find(c => c.weatherConditionId === condId)
            result.push(<li>{condInfo.conditionName}</li>)
        }

        return <ul className='ml-4 text-base list-disc'>
            {result}
       </ul>
    }

    return (
        <Tooltip placement='right-start'
          title={<div className='font-poppins text-ccColorDarkTeal'>
                    {props.customConditions === '[]' && <>
                            <div className='text-lg'>All Weather Conditions</div>
                            {renderConditions()}
                    </>
                    }
                    {props.customConditions !== '[]' && <>
                        <div className='text-lg'>{props.groupName}</div>
                        <div className='text-base mt-2 font-semibold'>Mapped conditions</div>
                        {renderCustomConditions()}
                    </>
                    }
                </div>}
          PopperProps={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  //offset: [0, 8],
                },
              },
            ],
          }}
          componentsProps={{
            tooltip: {
              sx: {
                maxWidth: 740, // Set custom width
                width: 740, // Set custom width
                whiteSpace: 'normal', // Allow wrapping
                backgroundColor: '#fff',     // White background
                color: '#000',               // Black text
                boxShadow: 3,                // Optional shadow
                border: '1px solid #ddd',    // Optional border                
              },
            },
          }}
        >
            <Iconify icon="material-symbols:info-outline" width={28} color={ccColorDarkTeal} />
        </Tooltip>
      );
}


export default function PageAdminSettings() {
    /*
    props:

    NO props 
    */
    const [currentTab, setCurrentTab] = useState("merge")


    return <div className='flex flex-col gap-3'>
        <CcTitle>Brand configuration hub</CcTitle>
        <div className='text-ccColorDarkTeal'>Configure your custom brand settings, including adding brand colours, custom fonts, ESP merge codes, time format preferences, and language mappings to ensure all the dots are joined up.</div>
            <TabSelector 
                items={[{id: 'merge', name: 'Merge Codes'},
                        {id: 'timers', name: 'Timers'},
                        {id: 'languageMapping', name: 'Language Mapping'},
                        {id: 'colors', name: 'Colors'},
                        {id: 'fonts', name: 'Fonts'},
                        {id: 'artFonts', name: 'Art Fonts'},
                        {id: 'quickBlocks', name: 'Font Formatting'},
                        {id: 'weatherIcons', name: 'Weather'},
                        ]}
                selectedItemId={currentTab}
                onChange={setCurrentTab}
            />


            {currentTab === 'timers' &&
                <TimerSettings />
            }
            {currentTab === 'merge' &&
                <MergeSettings />
            }
            {currentTab === 'languageMapping' &&
                <GeneralSettings />
            }
            {currentTab === 'colors' &&
                <PageAdminColors />
            }
            {currentTab === 'fonts' &&
                <PageAdminFonts />
            }
            {currentTab === 'artFonts' &&
                <PageAdminArtFonts />
            }
            {currentTab === 'quickBlocks' &&
                <PageAdminQuickBlocks />
            }
            {currentTab === 'weatherIcons' &&
                <WeatherIconSettings />
            }
        
    </div>
}